import { CircleCheck, CircleDashed, CircleDot, Clock, TriangleAlert } from "lucide-react";
import { cn } from "../cn";
import type { Tone } from "../status/tone";

const toneClass: Record<Tone, string> = {
  neutral: "bg-neutral-bg text-neutral-fg",
  info: "bg-info-bg text-info-fg",
  warning: "bg-warning-bg text-warning-fg",
  danger: "bg-danger-bg text-danger-fg",
  success: "bg-success-bg text-success-fg",
};

// never the colour alone (WCAG 1.4.1): every tone has its icon, every badge its text
const toneIcon: Record<Tone, typeof CircleCheck> = {
  neutral: CircleDashed,
  info: CircleDot,
  warning: Clock,
  danger: TriangleAlert,
  success: CircleCheck,
};

interface StatusBadgeProps {
  tone: Tone;
  /** A short sentence from the message catalog ("Awaiting approval"), never the enum value. */
  label: string;
  className?: string;
}

export function StatusBadge({ tone, label, className }: StatusBadgeProps) {
  const Icon = toneIcon[tone];
  return (
    <span
      className={cn(
        "inline-flex h-5 items-center gap-1 rounded-full px-2 text-xs font-medium whitespace-nowrap",
        toneClass[tone],
        className,
      )}
    >
      <Icon aria-hidden className="size-3" strokeWidth={2} />
      {label}
    </span>
  );
}
